import * as Config from '../../../../config';
import { useEffect } from "react";
import { useDispatch } from 'react-redux';
import { setTooltip } from "../redux/actions/index";

const useTooltip = (ref, title, description) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (Config.MOD_TOOLTIPS) {
      const el = document.getElementById(ref);
      const onMouseEnter = () => { dispatch(setTooltip({ title, description })) };
      const onMouseLeave = () => { dispatch(setTooltip(null)) };
      if (el) {
        el.addEventListener(`mouseenter`, onMouseEnter);
        el.addEventListener(`mouseleave`, onMouseLeave);
      }
      return () => {
        if (el) {
          el.removeEventListener('mouseenter', onMouseEnter);
          el.removeEventListener('mouseleave', onMouseLeave);
        }
      };
    }
  }, [ref, title, description, dispatch]);

  return null;
};

export default useTooltip;
